import { DecoratorNode } from 'lexical'
import { Suspense } from 'react'

export class ImageNode extends DecoratorNode {
  __src
  __alt
  __width
  __height

  static getType() {
    return 'image'
  }

  static clone(node) {
    return new ImageNode(
      node.__src,
      node.__alt,
      node.__width,
      node.__height,
      node.__key
    )
  }

  constructor(src, alt, width, height, key) {
    super(key)
    this.__src = src
    this.__alt = alt || ''
    this.__width = width || 'auto'
    this.__height = height || 'auto'
  }

  createDOM(config) {
    const div = document.createElement('div')
    div.style.display = 'inline-block'
    div.style.maxWidth = '100%'
    return div
  }

  updateDOM() {
    return false
  }

  decorate() {
    return (
      <img
        src={this.__src}
        alt={this.__alt}
        style={{
          maxWidth: '100%',
          height: 'auto',
          display: 'block',
          margin: '1rem 0',
        }}
        draggable="false"
      />
    )
  }

  exportJSON() {
    return {
      type: 'image',
      version: 1,
      src: this.__src,
      alt: this.__alt,
      width: this.__width,
      height: this.__height,
    }
  }

  static importJSON(serializedNode) {
    const { src, alt, width, height } = serializedNode
    return $createImageNode(src, alt, width, height)
  }

  getSrc() {
    return this.__src
  }

  getAlt() {
    return this.__alt
  }

  setAlt(alt) {
    const writable = this.getWritable()
    writable.__alt = alt
  }
}

export function $createImageNode(src, alt, width, height) {
  return new ImageNode(src, alt, width, height)
}

export function $isImageNode(node) {
  return node instanceof ImageNode
}
